import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import store from '@/store'
import { VuexOidcState } from 'vuex-oidc'

const HTTPClient: AxiosInstance = axios.create({
  baseURL: window.appConfig.VITE_API_BASE_URL,
  timeout: 10000
})

const HTTPGatewayClient: AxiosInstance = axios.create({
  baseURL: window.appConfig.VITE_API_GW_BASE_URL,
  timeout: 10000
})

const HTTPGatewayFileClient: AxiosInstance = axios.create({
  baseURL: window.appConfig.VITE_API_GW_BASE_URL,
  timeout: 10000
})

const HTTPGatewayFileBlobClient: AxiosInstance = axios.create({
  baseURL: `${window.appConfig.VITE_API_GW_BASE_URL}/attachments`,
  timeout: 10000
})

const HTTPKeyCloakClient: AxiosInstance = axios.create({
  baseURL: window.appConfig.VITE_API_GW_BASE_URL,
  timeout: 10000
})

const HTTPFileClient: AxiosInstance = axios.create({
  baseURL: window.appConfig.VITE_API_FILE_SERVICE_URL,
  timeout: 10000
})

HTTPClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const state = (store.state as any).oidcStore as VuexOidcState
    config.headers = config.headers || {}
    config.headers['Accept'] = 'application/json'
    config.headers['Content-Type'] = 'application/json'
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Authorization'] = `Bearer ${state.access_token}`
    return config
  },
  async (err: Error) => Promise.reject(err)
)

HTTPGatewayClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const state = (store.state as any).oidcStore as VuexOidcState
    config.headers = config.headers || {}
    config.headers['Accept'] = 'application/json'
    config.headers['Authorization'] = `Bearer ${state.access_token}`
    return config
  },
  async (err: Error) => Promise.reject(err)
)

HTTPGatewayFileClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const state = (store.state as any).oidcStore as VuexOidcState
    config.headers = config.headers || {}
    config.headers['Accept'] = 'application/json'
    config.headers['Content-Type'] = 'multipart/form-data'
    config.headers['Authorization'] = `Bearer ${state.access_token}`
    return config
  },
  async (err: Error) => Promise.reject(err)
)

HTTPGatewayFileBlobClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const state = (store.state as any).oidcStore as VuexOidcState
    config.headers = config.headers || {}
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Authorization'] = `Bearer ${state.access_token}`
    config.responseType = 'blob'
    return config
  },
  async (err: Error) => Promise.reject(err)
)

HTTPFileClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const state = (store.state as any).oidcStore as VuexOidcState
    config.headers = config.headers || {}
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Authorization'] = `Bearer ${state.access_token}`
    return config
  },
  async (err: Error) => Promise.reject(err)
)

HTTPKeyCloakClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const state = (store.state as any).oidcStore as VuexOidcState
    config.headers = config.headers || {}
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Authorization'] = `Bearer ${state.access_token}`
    return config
  },
  async (err: Error) => Promise.reject(err)
)

export {
  HTTPClient,
  HTTPFileClient,
  HTTPGatewayClient,
  HTTPGatewayFileClient,
  HTTPGatewayFileBlobClient,
  HTTPKeyCloakClient
}
